// ============================================================================
// Display formatting. Money is integer cents everywhere behind this file.
// ============================================================================

const money = new Intl.NumberFormat('en-US', {
  style: 'currency', currency: 'USD', minimumFractionDigits: 2
});
const moneyWhole = new Intl.NumberFormat('en-US', {
  style: 'currency', currency: 'USD', maximumFractionDigits: 0
});
const num = new Intl.NumberFormat('en-US');

/** 12345 -> "$123.45" */
export function currency(cents) {
  return money.format((Number(cents) || 0) / 100);
}

/** 12345 -> "$123" — for big dashboard numbers where cents are noise. */
export function currencyShort(cents) {
  return moneyWhole.format((Number(cents) || 0) / 100);
}

export function points(n) {
  return num.format(Number(n) || 0);
}

/** 45200 -> "45.2K" — follower counts and similar. */
export function compact(n) {
  const v = Number(n) || 0;
  if (v >= 1_000_000) return (v / 1_000_000).toFixed(1).replace(/\.0$/, '') + 'M';
  if (v >= 1_000)     return (v / 1_000).toFixed(1).replace(/\.0$/, '') + 'K';
  return num.format(v);
}

/** Points are worth $0.10 each. Must match points_to_cents() in 0002. */
export const CENTS_PER_POINT = 10;
export function pointsAsCents(p) {
  return (Number(p) || 0) * CENTS_PER_POINT;
}

export function percent(rate) {
  const v = Number(rate) || 0;
  // Stored as 0.1250; show as 12.5% without a trailing .0
  return (v * 100).toFixed(2).replace(/\.?0+$/, '') + '%';
}

export function date(iso) {
  if (!iso) return '';
  return new Date(iso).toLocaleDateString('en-US', {
    month: 'short', day: 'numeric', year: 'numeric'
  });
}

export function dateTime(iso) {
  if (!iso) return '';
  return new Date(iso).toLocaleString('en-US', {
    month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit'
  });
}

/** "3 days ago" — makes a dashboard feel live in a way absolute dates don't. */
export function relative(iso) {
  if (!iso) return '';
  const diff = Date.now() - new Date(iso).getTime();
  const mins = Math.round(diff / 60000);
  if (mins < 1)  return 'just now';
  if (mins < 60) return `${mins}m ago`;
  const hours = Math.round(mins / 60);
  if (hours < 24) return `${hours}h ago`;
  const days = Math.round(hours / 24);
  if (days < 30) return `${days}d ago`;
  return date(iso);
}

/** Title Case for enum-ish values: 'social_proof' -> 'Social Proof' */
export function humanize(value) {
  return String(value ?? '')
    .replace(/[_-]+/g, ' ')
    .replace(/\b\w/g, (c) => c.toUpperCase());
}

export function initials(name) {
  return String(name ?? '')
    .trim().split(/\s+/).slice(0, 2)
    .map((w) => w[0]?.toUpperCase() ?? '')
    .join('');
}
